
import { ClipLoader } from "react-spinners";
import "./loading.css";

const Loading = ({
  size = 22,
  color = "#000",
  text,
  ariaLabel = "Carregando",
  className = "",
}) => {
  return (
    <span className={`loading ${className}`.trim()} role="status" aria-label={ariaLabel}>
      <ClipLoader color={color} size={size} aria-label={ariaLabel} />
      {text && <span className="loading_text">{text}</span>}
    </span>
  );
};

export default Loading;
